module.exports = __webpack_public_path__ + "img/bg_block_m.fcfb7b2d.png";